import React from 'react';
import './Section3.css';

function Section3() {
  return (
    <div className='fib-banner-wrapper lohp-row'>
      <div className='fib-banner lohp-inner-row max-width-container'>
        <div className='grid-15'></div>
      </div>
    </div>
  );
}

export default Section3;
